import React, { useRef } from "react";
import styles from "./index.module.css";
import menuIcon from "../../../../assets/icons/ellipsisMenu.png";
import addSection from "../../../../assets/icons/mobileIcons/duplicate.png";
import deleteSectionIcon from "../../../../assets/icons/mobileIcons/deleteOutlinedBlack.png";
import shareIcon from "../../../../assets/icons/mobileIcons/share.png";
import { message } from "antd";
import {
    openSectionDeleteModal,
    setSectionsDiff,
    setSelectedCollection,
    setSelectedHeader,
    setSelectedScreen,
    setSelectedSection
} from "../../../../redux/slice/dashboardSlice.js";
import {
    updateShareModalDescripition,
    updateShareModalImage,
    updateShareModalOpen,
    updateShareShortLink,
    updateWallUser
} from "../../../../redux/slice/wallSlice.js";
import { duplicateStoreSection, deleteSection, findDiff } from "../../../Builder/builderServices/utils.js";
import { useDispatch } from "react-redux";

const index = ({ collection, isAnyMenuOpened, isMenuOpened, setIsMenuOpened, closeMenu }) => {
    const dispatch = useDispatch();
    const productCountRef = useRef();
    const productsContainerRef = useRef();

    const getImageUrl = (productImg) => {
        if (!productImg.includes("https:")) {
            productImg = "https:" + productImg;
        }
        return productImg;
    };
    const onDuplicate = (e) => {
        e.stopPropagation();
        duplicateStoreSection(collection);
        message.success("Duplicate section created");
        closeMenu();
    };
    const onDelete = async (e) => {
        e.stopPropagation();
        dispatch(openSectionDeleteModal(true));
        dispatch(setSelectedCollection(collection));
        closeMenu();
    };
    const onShare = (event) => {
        try {
            event.stopPropagation();
            dispatch(updateShareModalOpen());
            dispatch(updateShareModalDescripition(collection?.title ? collection.title : "My Collection"));
            dispatch(updateShareModalImage(getImageUrl(collection?.links[0]?.metaData?.response?.image) || ""));
            dispatch(updateShareShortLink(`${process.env.REACT_APP_URL}/collection/${collection?.id}`));
        } catch (error) {
            console.error("Error handling share icon click:", error);
        }
        closeMenu();
    };

    const handleClick = () => {
        if (isAnyMenuOpened) {
            closeMenu();
        } else {
            dispatch(setSelectedCollection(collection));
            dispatch(setSelectedScreen("collection"));
        }
    };

    const handleScroll = (e) => {
        const scrollLeft = e.target.scrollLeft; // Current horizontal scroll position
        const scrollWidth = e.target.scrollWidth; // Total scrollable width
        const clientWidth = e.target.clientWidth; // Visible width of the container

        const remainingScrollRight = scrollWidth - clientWidth - scrollLeft;
        if (!productCountRef.current) return;

        if (remainingScrollRight <= 50) {
            productCountRef.current.style.visibility = "hidden";
        } else {
            productCountRef.current.style.visibility = "visible";
            let remainingProducts = (remainingScrollRight - 33) / 75 + 1;
            productCountRef.current.innerText = `+${Math.floor(remainingProducts)}`;
        }
    };
    return (
        <div className={styles.collectionContainer} onClick={handleClick}>
            <div className={styles.headingContainer}>
                <span className={styles.title}>{collection.title ? collection.title : "My Collection"}</span>
                <img
                    className={styles.menu}
                    src={menuIcon}
                    alt="ellipses-icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsMenuOpened(!isMenuOpened);
                    }}
                />
            </div>
            <div className={styles.productsContainer} onScroll={handleScroll}>
                {collection.links.map((product, index) => {
                    if (product.isDeleted) return <></>;
                    return <img key={index} className={styles.productImg} src={getImageUrl(product?.metaData?.response?.image)} />;
                })}
                {collection.links.length - 4 > 0 && (
                    <div ref={productCountRef} className={styles.productCount}>
                        +{+collection.links.length - 4}
                    </div>
                )}
            </div>
            {isMenuOpened && (
                <ul className={styles.sectionMenu}>
                    <li className={styles.sectionMenuItem} onClick={onDuplicate}>
                        <img src={addSection} />
                        <span>Duplicate</span>
                    </li>
                    <li className={styles.sectionMenuItem} onClick={onDelete}>
                        <img src={deleteSectionIcon} />
                        <span>Delete</span>
                    </li>
                    {collection._id && (
                        <li className={styles.sectionMenuItem} onClick={onShare}>
                            <img src={shareIcon} />
                            <span>Share</span>
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default index;
